import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField
} from "@material-ui/core";
import { useForm } from "react-hook-form";

export default function FormOnUsers(props) {
  const { open, handleClose, fetchAPI } = props;
  const { register, handleSubmit, errors, } = useForm();

  const onSubmit = async (data) => {
    await fetchAPI("add", data);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Add On Services</DialogTitle>
          <DialogContent>
            <Grid container spacing={3}>
              {/* Name */}
              <Grid item xs={12} sm={12}>
                <TextField
                  id="nama"
                  name="nama"
                  label="Nama Layanan"
                  error={errors.nama}
                  fullWidth
                  placeholder="Type your Nama Layanan"
                  type="string"
                  variant="outlined"
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Nama Layanan tidak boleh kosong",
                    },
                    // pattern: {
                    //   value: /^[a-zA-Z]+$/,
                    //   message: "Name Without Special Character",
                    // },
                    // minLength: {
                    //   value: 4,
                    //   message: " must be at least 4 alphas",
                    // },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    errors.nama && errors.nama.message
                  }
                />
              </Grid>

              {/* Username */}
              <Grid item xs={12} sm={12}>
                <TextField
                  id="deskripsi"
                  name="deskripsi"
                  label="Description"
                  placeholder="Type your deskripsi"
                  type="string"
                  variant="outlined"
                  error={errors.deskripsi}
                  inputRef={register({
                    required: {
                      value: true,
                      message: "Description tidak boleh kosong",
                    },
                    // minLength: {
                    //   value: 4,
                    //   message: " must be at least 4 alphas",
                    // },
                    // pattern: {
                    //   value: /^[a-zA-Z0-9]{4,15}$/,
                    //   message: "Username without Special Character",
                    // },
                  })}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    errors.deskripsi && errors.deskripsi.message
                  }
                  fullWidth
                />
              </Grid>

            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary">
              Add
            </Button>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
